import { InsightsQuery } from 'src/insightsQuery';

export interface CustomFieldIssue {
  type: CustomFieldIssue.Type;
  location: InsightsQuery.TextLocation;
  message: string;
}

export namespace CustomFieldIssue {
  export enum Type {
    Info,
    Warning,
    Error,
  }

  export const
    FIELD_FORMAT_MISMATCH = {
      disabled: false,
      format(...args: any[]) {
        return `The query evaluates to <strong>${args[0]}</strong> which is incompatible with <strong>${args[1]}</strong>.`;
      }
    },

    FIELD_FORMAT_DOWNCAST = {
      disabled: false,
      format(...args: any[]) {
        return `The query evaluates to <strong>${args[0]}</strong> which will be coerced into <strong>${args[1]}</strong>.`;
      }
    },

    CIRCULAR_DEPENDENCY = {
      disabled: false,
      format(...args: any[]) {
        return `Circular dependency has been detected: ${args[0]}`;
      }
    },

    UNEXPECTED_ERROR = {
      disabled: false,
      format(...args: any[]) {
        return 'An unexpected error occurred';
      }
    },

    NOT_A_BOOLEAN = {
      disabled: false,
      format() {
        return 'The value is not a boolean.';
      }
    },
    NOT_A_NUMBER = {
      disabled: false,
      format() {
        return 'The value is not a number.';
      }
    },
    NOT_TEXT = {
      disabled: false,
      format() {
        return 'The value is not text.';
      }
    },
    IMPLICIT_CAST_TO_TEXT = {
      disabled: false,
      format(...args: any[]) {
        return 'The value will be converted into text.';
      }
    },

    INVALID_CONVERSION = {
      disabled: false,
      format(...args: any[]) {
        return `'${args[0]}' is <strong>${args[1]}</strong> which is incompatible with <strong>${args[2]}</strong>`;
      }
    },

    OPERATION_EXPECTS_NUMBERS = {
      disabled: false,
      format(...args: any[]) {
        return `<strong>${args[1]}</strong> expects two numbers.`;
      }
    },

    UNKNOWN_FUNCTION = {
      disabled: false,
      format(...args: any[]) {
        return `<strong>${args[0]}</strong> is not a recognized function.`;
      }
    },
    EXPECTED_N_ARGUMENTS = {
      disabled: false,
      format(...args: any[]) {
        // IN-927
        return 'Incorrect number of arguments for this function.';
        //return `<strong>${args[0]}</strong> expects ` + (args[1] > 1 ? (args[1] + ' arguments') : 'one argument');
      }
    },
    EXPECTED_AT_LEAST_ARGUMENTS = {
      disabled: false,
      format(...args: any[]) {
        // IN-927
        return 'Incorrect number of arguments for this function.';
        // return `<strong>${args[0]}</strong> expects at least ` + (args[1] > 1 ? (args[1] + ' arguments') : 'one argument');
      }
    },
    EXPECTED_AT_MOST_ARGUMENTS = {
      disabled: false,
      format(...args: any[]) {
        // IN-927
        return 'Incorrect number of arguments for this function.';
        // return `<strong>${args[0]}</strong> expects at most ` + (args[1] > 1 ? (args[1] + ' arguments') : 'one argument');
      }
    },
    INVALID_FUNCTION_ARGS = {
      disabled: false,
      format(...args: any[]) {
        return `<strong>${args[0]}</strong> cannot be called with the specified arguments.`;
      }
    },

    AGGREGATION_EXPECTS_NUMERIC_FIELD = {
      disabled: false,
      format(...args: any[]) {
        return `<strong>${args[0]}</strong> expects a numeric field.`;
      }
    },

    UNKNOWN_FIELD = {
      disabled: false,
      format(...args: any[]) {
        return `<strong>${args[0]}</strong> is not a recognized field.`;
      }
    },
    AMBIGUOUS_FIELD = {
      disabled: false,
      format(...args: any[]) {
        return `<strong>${args[0]}</strong> is ambiguous. The potential matches are ${args[1]}.`;
      }
    },

    ALREADY_AGGREGATED = {
      disabled: false,
      format(...args: any[]) {
        return `The <strong>${args[0]}</strong> field is already aggregated.`;
      }
    },

    BROKEN_FIELD = {
      disabled: false,
      format(...args: any[]) {
        return `The <strong>${args[0]}</strong> field has one or more errors.`;
      }
    },

    
    IN_924_INVALID_CONCATENATION_OPERANDS = {
      disabled: false,
      format(...args: any[]) {
        return `Non-text operand in text concatenation; cast to Text`;
      }
    },

    IN_7226_INVALID_TOUPPER_TOLOWER_ARG = {
      disabled: false,
      format(...args: any[]) {
        return `Invalid data type for <strong>${args[0]}</strong>; text input expected.`;
      }
    },

    IN_927_IF_EXPECTS_BOOLEAN = {
      disabled: false,
      format(...args: any[]) {
        return `<strong>IF</strong> condition must evaluate to <strong>TRUE</strong> or <strong>FALSE</strong>.`;
      }
    },
    
    IN_927_INCOMPATIBLE_BRANCH = {
      disabled: false,
      format(...args: any[]) {
        return `<strong>THEN</strong> and <strong>ELSE</strong> results must return the same type.`;
      }
    },

    IN_927_IFBLANK_TEXT = {
      disabled: false,
      format(...args: any[]) {
        return `<strong>IFBLANK</strong> can only be used with text fields.`;
      }
    },
    
    IN_7625_AGGR_FUNC_EXPECTS_FIELD = {
      disabled: false,
      format(...args: any[]) {
        return `<strong>${args[0]}</strong> only accepts field expressions.`;
      }
    }
    ;
}
